import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';

export default function NewProject(props) {
    const [url, setUrl] = useState('');
    const [projectId, setProjectId] = useState('');
    const saveProject = () => {
        axios.post(`https://backend-minerva-entity.pathrover.ir/api/project/AddProject`, { uRL: url, projectId: projectId })
            .then(res => {
                setUrl('');
                setProjectId('');
                props.onSubmit();
            })
    }
    return (
        <>
            <Dialog
                open={props.isOpen}
                onClose={props.onClose}>
                <DialogTitle>Add new project</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="url"
                        name="url"
                        label="Project URL"
                        fullWidth
                        value={url}
                        onChange={(ev) => setUrl(ev.target.value)}
                    />
                    <TextField
                        required
                        margin="dense"
                        id="projectId"
                        name="projectId"
                        label="Project ID"
                        fullWidth
                        value={projectId}
                        onChange={(ev) => setProjectId(ev.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose}>Cancel</Button>
                    <Button onClick={saveProject}>Save</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}